import { css } from '@emotion/react'
import { Button, Flow, Heading, Icon, Theme, Tooltip, useTheme } from 'bold-ui'
import { SIDE_MENU_Z_INDEX } from 'components/layout/SideMenu/SideMenuNav'
import { useState } from 'react'
import { generatePath, useHistory, useRouteMatch } from 'react-router'
import { VisualizacaoTerritorialBuscaFormModel } from 'view/visualizacaoTerritorial/model'

import { MapaSidebarBuscaContent } from './MapaSidebarBuscaContent'
import {
  MAPA_SIDEBAR_NAV_ITEM_ROUTE,
  MAPA_SIDEBAR_NAV_ITEMS,
  MapaSidebarNavItem,
  MapaSidebarNavItemEnum,
  parseMapaSidebarNavItem,
} from './MapaSidebarNavItem'

interface MapaViewSidebarProps {
  searchInitialValues: VisualizacaoTerritorialBuscaFormModel
  onSearchSubmit: (values: VisualizacaoTerritorialBuscaFormModel) => void
}

export function MapaViewSidebar(props: Readonly<MapaViewSidebarProps>) {
  const { searchInitialValues, onSearchSubmit } = props

  const match = useRouteMatch<{ mapaSidebarNavItem?: string }>()
  const history = useHistory()
  const selectedNavItem = parseMapaSidebarNavItem(match.params.mapaSidebarNavItem)

  const [isSidebarOpen, setIsSidebarOpen] = useState(true)

  const theme = useTheme()
  const styles = createStyles(theme)

  const handleSelectNavItem = (navItem: MapaSidebarNavItemEnum) => {
    history.push(generatePath(match.path, { mapaSidebarNavItem: MAPA_SIDEBAR_NAV_ITEM_ROUTE[navItem] }))
  }

  return (
    <Flow direction='horizontal' gap={0} style={styles.sidebar}>
      <Flow direction='vertical' justifyItems='center' style={styles.sidebarNav}>
        <Flow direction='vertical' gap={0} style={styles.sidebarNavFlow}>
          {Object.values(MapaSidebarNavItemEnum).map((navItem) => (
            <MapaSidebarNavItem
              key={navItem}
              navItem={navItem}
              selectedNavItem={selectedNavItem}
              onSelect={handleSelectNavItem}
            />
          ))}
        </Flow>
        {!isSidebarOpen && (
          <Tooltip text='Exibir'>
            <Button skin='ghost' size='small' onClick={() => setIsSidebarOpen(true)} style={styles.sidebarNavButton}>
              <Icon icon='arrowRight' />
            </Button>
          </Tooltip>
        )}
      </Flow>
      {isSidebarOpen && (
        <Flow direction='vertical' style={styles.sidebarContent}>
          <Flow direction='vertical' style={styles.sidebarContentInner}>
            <Heading level={2}>{MAPA_SIDEBAR_NAV_ITEMS[selectedNavItem].label}</Heading>
            <div css={styles.sidebarContentInnerBody}>
              {selectedNavItem === MapaSidebarNavItemEnum.BUSCA && (
                <MapaSidebarBuscaContent initialValues={searchInitialValues} onSubmit={onSearchSubmit} />
              )}
              {selectedNavItem === MapaSidebarNavItemEnum.AREAS && <Heading level={2}>Áreas</Heading>}
              {selectedNavItem === MapaSidebarNavItemEnum.AJUDA && <Heading level={2}>Ajuda</Heading>}
            </div>
          </Flow>
          <Button skin='ghost' block style={styles.sidebarContentButton} onClick={() => setIsSidebarOpen(false)}>
            <Flow direction='horizontal' gap={0.5}>
              <Icon icon='arrowLeft' />
              Ocultar lateral
            </Flow>
          </Button>
        </Flow>
      )}
    </Flow>
  )
}

const createStyles = (theme: Theme) => ({
  sidebar: css`
    box-shadow: 2px 0 4px -10px rgba(0, 0, 0, 0.2), 1px 0 10px -10px rgba(0, 0, 0, 0.12),
      4px 0 5px -3px rgba(0, 0, 0, 0.14);
    z-index: ${SIDE_MENU_Z_INDEX - 1};
  `,
  sidebarNav: css`
    width: 3.5rem;
    border-right: 1px solid ${theme.pallete.divider};
    grid-template-rows: 1fr auto;
    padding-bottom: 1rem;
  `,
  sidebarNavFlow: css`
    width: 100%;
  `,
  sidebarNavButton: css`
    padding-left: 0;
    padding-right: 0;
    width: 2rem;
  `,
  sidebarContent: css`
    width: 18.5rem;
    border-right: 1px solid ${theme.pallete.divider};
    grid-template-rows: 1fr auto;
  `,
  sidebarContentInner: css`
    padding: 0.5rem 1rem;
  `,
  sidebarContentInnerBody: css``,
  sidebarContentButton: css`
    border-radius: 0;
    justify-content: start;
  `,
})
